import { Signal } from "@/utils/signals";
import { determineWidgetPath } from '@/components/editor/widget-tree'
import { WidgetConfig } from '@/components/WidgetConfiguration'

export type RevealRequest = {
  path: string
  mainArea: WidgetConfig
}

export const revealSignal = new Signal<RevealRequest>()

export function findNestedAreaIndex(
  areas: (WidgetConfig | null | undefined)[],
  targetPath: string,
  mainArea: WidgetConfig
) {
  return areas.findIndex((area): boolean => {
    const areaPath = area ? determineWidgetPath(area, mainArea) : null
    if (areaPath === targetPath) return true
    return !!area && (findNestedAreaIndex(area.areas ?? [], targetPath, mainArea) !== -1)
  })
}
